const defaultState = {
  isLoading: false,
  config: { colors: [] },
};

export default defaultState;
